import { useMemo } from "react";
import useDocs from "./useDocs";
import { DocsKind } from "./constants";
import { flattenCommentArray, extractType, extractDescription } from "./utils";

const usePropsDocs = (entry, namespace) => {
  const docs = useDocs(entry, DocsKind.Interface, namespace);

  return useMemo(() => {
    if (!docs) return null;

    const { name, children } = docs;

    return {
      name,
      props: children
        ?.filter((c) => c.kind === DocsKind.Property)
        .map((c) => {
          return {
            name: c.name,
            type: extractType(c.type),
            description:
              flattenCommentArray(c.comment?.summary) ??
              extractDescription(c.type),
            optional: !!c.flags?.isOptional,
          };
        }),
    };
  }, [docs]);
};

export default usePropsDocs;
